import React, { forwardRef } from "react";
import styled from "styled-components";
import { Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { colors } from "utils";

const Container = styled(Form)`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  padding: 12px 16px;
  background-color: #FFFEFE;
  border-radius: 8px;
  flex: 0 1 ${({ $maxWidth }) => $maxWidth}px;
`;

const Input = styled(Form.Control)`
  flex: 1;
  padding: 0;
  border: none;
  background: transparent;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.25px;
  color: ${colors.nightlyWoods500};
  &::placeholder {
    color: #ACAFAD;
  }
  &:focus {
    background: transparent;
    box-shadow: none;
    outline: none;
  }
`;

const IconButton = styled(Button)`
  background: transparent;
  border: none;
  color: ${colors.nightlyWoods500};
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  &:hover, &:focus, &:active, &:disabled {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    color: ${colors.nightlyWoods500} !important;
    opacity: 1;
  }
`;

export const SearchBar = forwardRef(function SearchBar(
  {
    value,
    onChange,
    onSubmit,
    placeholder = "Search",
    ariaLabel,
    isLoading = false,
    disabled = false,
    maxWidth = 500,
    className,
  },
  ref,
) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(e);
  };

  return (
    <Container onSubmit={handleSubmit} className={className} $maxWidth={maxWidth}>
      <Input
        ref={ref}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        aria-label={ariaLabel || placeholder}
        disabled={disabled}
      />
      <IconButton type="submit" disabled={disabled || isLoading} aria-label="Search">
        <FontAwesomeIcon icon={isLoading ? faSpinner : faSearch} spin={isLoading} />
      </IconButton>
    </Container>
  );
});
